import { render, staticRenderFns } from "./LinhaDeItemResumo.vue?vue&type=template&id=8d3d2db4&scoped=true"
import script from "./LinhaDeItemResumo.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeItemResumo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeItemResumo.vue?vue&type=style&index=0&id=8d3d2db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3d2db4",
  null
  
)

export default component.exports